import _createForOfIteratorHelper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { getUrlRegExp, isIncluded, getBucketRanges, hash, chooseVariation, getQueryStringOverride, inNamespace } from "./util";
import { evalCondition } from "./mongrule";
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var base64ToBuf = function base64ToBuf(b) {
  return Uint8Array.from(atob(b), function (c) {
    return c.charCodeAt(0);
  });
};
export var GrowthBook = /*#__PURE__*/function () {
  // eslint-disable-next-line

  function GrowthBook() {
    _classCallCheck(this, GrowthBook);
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _defineProperty(this, "_renderer", null);
    _defineProperty(this, "_trackedExperiments", new Set());
    _defineProperty(this, "_trackedFeatures", {});
    _defineProperty(this, "debug", false);
    _defineProperty(this, "subscriptions", new Set());
    _defineProperty(this, "_rtQueue", []);
    _defineProperty(this, "_rtTimer", 0);
    _defineProperty(this, "assigned", new Map());
    _defineProperty(this, "_forcedFeatureValues", new Map());
    _defineProperty(this, "_attributeOverrides", {});
    this.context = context;
    if (isBrowser && context.enableDevMode) {
      window._growthbook = this;
      document.dispatchEvent(new Event("gbloaded"));
    }
  }
  _createClass(GrowthBook, [{
    key: "render",
    value: function render() {
      if (this._renderer) {
        this._renderer();
      }
    }
  }, {
    key: "setFeatures",
    value: function setFeatures(features) {
      this.context.features = features;
      this.render();
    }
  }, {
    key: "setEncryptedFeatures",
    value: function () {
      var _setEncryptedFeatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(encryptedString, encryptionKey, subtle) {
        var key, _encryptedString$spli, _encryptedString$spli2, iv, cipherText, plainTextBuffer;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              subtle = subtle || globalThis.crypto && globalThis.crypto.subtle;
              if (subtle) {
                _context.next = 3;
                break;
              }
              throw new Error("No SubtleCrypto implementation found");
            case 3:
              _context.prev = 3;
              _context.next = 6;
              return subtle.importKey("raw", base64ToBuf(encryptionKey), {
                name: "AES-CBC",
                length: 128
              }, true, ["encrypt", "decrypt"]);
            case 6:
              key = _context.sent;
              _encryptedString$spli = encryptedString.split("."), _encryptedString$spli2 = _slicedToArray(_encryptedString$spli, 2), iv = _encryptedString$spli2[0], cipherText = _encryptedString$spli2[1];
              _context.next = 10;
              return subtle.decrypt({
                name: "AES-CBC",
                iv: base64ToBuf(iv)
              }, key, base64ToBuf(cipherText));
            case 10:
              plainTextBuffer = _context.sent;
              this.setFeatures(JSON.parse(new TextDecoder().decode(plainTextBuffer)));
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);
              throw new Error("Failed to decrypt features");
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 14]]);
      }));
      function setEncryptedFeatures(_x, _x2, _x3) {
        return _setEncryptedFeatures.apply(this, arguments);
      }
      return setEncryptedFeatures;
    }()
  }, {
    key: "setAttributes",
    value: function setAttributes(attributes) {
      this.context.attributes = attributes;
      this.render();
    }
  }, {
    key: "setAttributeOverrides",
    value: function setAttributeOverrides(overrides) {
      this._attributeOverrides = overrides;
      this.render();
    }
  }, {
    key: "setForcedVariations",
    value: function setForcedVariations(vars) {
      this.context.forcedVariations = vars || {};
      this.render();
    }
    // eslint-disable-next-line
  }, {
    key: "setForcedFeatures",
    value: function setForcedFeatures(map) {
      this._forcedFeatureValues = map;
      this.render();
    }
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return _objectSpread(_objectSpread({}, this.context.attributes), this._attributeOverrides);
    }
  }, {
    key: "getFeatures",
    value: function getFeatures() {
      return this.context.features || {};
    }
  }, {
    key: "subscribe",
    value: function subscribe(cb) {
      var _this = this;
      this.subscriptions.add(cb);
      return function () {
        _this.subscriptions.delete(cb);
      };
    }
  }, {
    key: "getAllResults",
    value: function getAllResults() {
      return new Map(this.assigned);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      // Release references to save memory
      this.subscriptions.clear();
      this.assigned.clear();
      this._trackedExperiments.clear();
      this._trackedFeatures = {};
      this._rtQueue = [];
      if (this._rtTimer) {
        clearTimeout(this._rtTimer);
      }
      if (isBrowser && window._growthbook === this) {
        delete window._growthbook;
      }
    }
  }, {
    key: "setRenderer",
    value: function setRenderer(renderer) {
      this._renderer = renderer;
    }
  }, {
    key: "forceVariation",
    value: function forceVariation(key, variation) {
      this.context.forcedVariations = this.context.forcedVariations || {};
      this.context.forcedVariations[key] = variation;
      this.render();
    }
  }, {
    key: "run",
    value: function run(experiment) {
      var result = this._run(experiment, null);
      this.fireSubscriptions(experiment, result);
      return result;
    }
  }, {
    key: "fireSubscriptions",
    value: function fireSubscriptions(experiment, result) {
      var key = experiment.key;

      // If assigned variation has changed, fire subscriptions
      var prev = this.assigned.get(key);
      // TODO: what if the experiment definition has changed?
      if (!prev || prev.result.inExperiment !== result.inExperiment || prev.result.variationId !== result.variationId) {
        this.assigned.set(key, {
          experiment: experiment,
          result: result
        });
        this.subscriptions.forEach(function (cb) {
          try {
            cb(experiment, result);
          } catch (e) {
            console.error(e);
          }
        });
      }
    }
  }, {
    key: "trackFeatureUsage",
    value: function trackFeatureUsage(key, res) {
      var _this2 = this;
      // Don't track feature usage that was forced via an override
      if (res.source === "override") return;

      // Only track a feature once, unless the assigned value changed
      var stringifiedValue = JSON.stringify(res.value);
      if (this._trackedFeatures[key] === stringifiedValue) return;
      this._trackedFeatures[key] = stringifiedValue;

      // Fire user-supplied callback
      if (this.context.onFeatureUsage) {
        try {
          this.context.onFeatureUsage(key, res);
        } catch (e) {
          // Ignore feature usage callback errors
        }
      }

      // In browser environments, queue up feature usage to be tracked in batches
      if (!isBrowser || !window.fetch) return;
      this._rtQueue.push({
        key: key,
        on: res.on
      });
      if (!this._rtTimer) {
        this._rtTimer = window.setTimeout(function () {
          // Reset the queue
          _this2._rtTimer = 0;
          var q = _toConsumableArray(_this2._rtQueue);
          _this2._rtQueue = [];

          // Skip logging if a real-time usage key is not configured
          if (!_this2.context.realtimeKey) return;
          window.fetch("https://rt.growthbook.io/?key=".concat(_this2.context.realtimeKey, "&events=").concat(encodeURIComponent(JSON.stringify(q))), {
            cache: "no-cache",
            mode: "no-cors"
          }).catch(function () {
            // TODO: retry in case of network errors?
          });
        }, this.context.realtimeInterval || 2000);
      }
    }
  }, {
    key: "getFeatureResult",
    value: function getFeatureResult(key, value, source, ruleId) {
      var experiment = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var result = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      var ret = {
        value: value,
        on: !!value,
        off: !value,
        source: source,
        ruleId: ruleId || ""
      };
      if (experiment) ret.experiment = experiment;
      if (result) ret.experimentResult = result;

      // Track the usage of this feature in real-time
      this.trackFeatureUsage(key, ret);
      return ret;
    }
  }, {
    key: "isOn",
    value: function isOn(key) {
      return this.evalFeature(key).on;
    }
  }, {
    key: "isOff",
    value: function isOff(key) {
      return this.evalFeature(key).off;
    }
  }, {
    key: "getFeatureValue",
    value: function getFeatureValue(key, defaultValue) {
      var _this$evalFeature$val;
      return (_this$evalFeature$val = this.evalFeature(key).value) !== null && _this$evalFeature$val !== void 0 ? _this$evalFeature$val : defaultValue;
    }

    // eslint-disable-next-line
  }, {
    key: "feature",
    value: function feature(id) {
      return this.evalFeature(id);
    }

    // eslint-disable-next-line
  }, {
    key: "evalFeature",
    value: function evalFeature(id) {
      var _feature$defaultValue, _feature$defaultValue2;
      // Global override
      if (this._forcedFeatureValues.has(id)) {
        process.env.NODE_ENV !== "production" && this.log("Global override", {
          id: id,
          value: this._forcedFeatureValues.get(id)
        });
        return this.getFeatureResult(id, this._forcedFeatureValues.get(id), "override");
      }

      // Unknown feature id
      if (!this.context.features || !this.context.features[id]) {
        process.env.NODE_ENV !== "production" && this.log("Unknown feature", {
          id: id
        });
        return this.getFeatureResult(id, null, "unknownFeature");
      }

      // Get the feature
      var feature = this.context.features[id];

      // Loop through the rules
      if (feature.rules) {
        var _iterator = _createForOfIteratorHelper(feature.rules),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var rule = _step.value;
            // If it's a conditional rule, skip if the condition doesn't pass
            if (rule.condition && !this.conditionPasses(rule.condition)) {
              process.env.NODE_ENV !== "production" && this.log("Skip rule because of condition", {
                id: id,
                rule: rule
              });
              continue;
            }
            // Feature value is being forced
            if ("force" in rule) {
              // Skip if coverage is reduced and user not included
              if ("coverage" in rule) {
                var _this$getHashAttribut = this.getHashAttribute(rule.hashAttribute),
                  hashValue = _this$getHashAttribut.hashValue;
                if (!hashValue) {
                  process.env.NODE_ENV !== "production" && this.log("Skip rule because of missing hashAttribute", {
                    id: id,
                    rule: rule
                  });
                  continue;
                }
                var n = hash(hashValue + id);
                if (n > rule.coverage) {
                  process.env.NODE_ENV !== "production" && this.log("Skip rule because of coverage", {
                    id: id,
                    rule: rule
                  });
                  continue;
                }
              }
              process.env.NODE_ENV !== "production" && this.log("Force value from rule", {
                id: id,
                rule: rule
              });

              // eslint-disable-next-line
              return this.getFeatureResult(id, rule.force, "force", rule.id);
            }
            if (!rule.variations) {
              process.env.NODE_ENV !== "production" && this.log("Skip invalid rule", {
                id: id,
                rule: rule
              });
              continue;
            }
            // For experiment rules, run an experiment
            var exp = {
              variations: rule.variations,
              key: rule.key || id
            };
            if ("coverage" in rule) exp.coverage = rule.coverage;
            if (rule.weights) exp.weights = rule.weights;
            if (rule.hashAttribute) exp.hashAttribute = rule.hashAttribute;
            if (rule.namespace) exp.namespace = rule.namespace;

            // Only return a value if the user is part of the experiment
            var res = this._run(exp, id);
            this.fireSubscriptions(exp, res);
            if (res.inExperiment) {
              return this.getFeatureResult(id, res.value, "experiment", rule.id, exp, res);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      process.env.NODE_ENV !== "production" && this.log("Use default value", {
        id: id,
        value: (_feature$defaultValue = feature.defaultValue) !== null && _feature$defaultValue !== void 0 ? _feature$defaultValue : null
      });

      // Fall back to using the default value
      return this.getFeatureResult(id, (_feature$defaultValue2 = feature.defaultValue) !== null && _feature$defaultValue2 !== void 0 ? _feature$defaultValue2 : null, "defaultValue");
    }
  }, {
    key: "conditionPasses",
    value: function conditionPasses(condition) {
      return evalCondition(this.getAttributes(), condition);
    }
  }, {
    key: "_run",
    value: function _run(experiment, featureId) {
      var _experiment$coverage;
      var key = experiment.key;
      var numVariations = experiment.variations.length;

      // 1. If experiment has less than 2 variations, return immediately
      if (numVariations < 2) {
        process.env.NODE_ENV !== "production" && this.log("Invalid experiment", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      }

      // 2. If the context is disabled, return immediately
      if (this.context.enabled === false) {
        process.env.NODE_ENV !== "production" && this.log("Context disabled", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      }

      // 2.5. Merge in experiment overrides from the context
      experiment = this.mergeOverrides(experiment);

      // 3. If a variation is forced from a querystring, return the forced variation
      var qsOverride = getQueryStringOverride(key, this.getContextUrl(), numVariations);
      if (qsOverride !== null) {
        process.env.NODE_ENV !== "production" && this.log("Force via querystring", {
          id: key,
          variation: qsOverride
        });
        return this.getResult(experiment, qsOverride, false, featureId);
      }

      // 4. If a variation is forced in the context, return the forced variation
      if (this.context.forcedVariations && key in this.context.forcedVariations) {
        var variation = this.context.forcedVariations[key];
        process.env.NODE_ENV !== "production" && this.log("Force via dev tools", {
          id: key,
          variation: variation
        });
        return this.getResult(experiment, variation, false, featureId);
      }

      // 5. Exclude if a draft experiment or not active
      if (experiment.status === "draft" || experiment.active === false) {
        process.env.NODE_ENV !== "production" && this.log("Skip because inactive", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      }

      // 6. Get the hash attribute and return if empty
      var _this$getHashAttribut2 = this.getHashAttribute(experiment.hashAttribute),
        hashValue = _this$getHashAttribut2.hashValue;
      if (!hashValue) {
        process.env.NODE_ENV !== "production" && this.log("Skip because missing hashAttribute", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      }

      // 7. Exclude if user not in experiment.namespace
      if (experiment.namespace && !inNamespace(hashValue, experiment.namespace)) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of namespace", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      }

      // 7.5. Exclude if experiment.include returns false or throws
      if (experiment.include && !isIncluded(experiment.include)) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of include function", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      }

      // 8. Exclude if condition is false
      if (experiment.condition && !this.conditionPasses(experiment.condition)) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of condition", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      }

      // 8.1. Exclude if user is not in a required group
      if (experiment.groups && !this.hasGroupOverlap(experiment.groups)) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of groups", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      }

      // 8.2. Exclude if not on a targeted url
      if (experiment.url && !this.urlIsValid(experiment.url)) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of url", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      }

      // 9. Get bucket ranges and choose variation
      var ranges = getBucketRanges(numVariations, (_experiment$coverage = experiment.coverage) !== null && _experiment$coverage !== void 0 ? _experiment$coverage : 1, experiment.weights);
      var n = hash(hashValue + key);
      var assigned = chooseVariation(n, ranges);

      // 10. Return if not in experiment
      if (assigned < 0) {
        process.env.NODE_ENV !== "production" && this.log("Skip because of coverage", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      }

      // 11. Experiment has a forced variation
      if ("force" in experiment) {
        var _experiment$force;
        process.env.NODE_ENV !== "production" && this.log("Force variation", {
          id: key,
          variation: experiment.force
        });
        return this.getResult(experiment, (_experiment$force = experiment.force) !== null && _experiment$force !== void 0 ? _experiment$force : -1, false, featureId);
      }

      // 12. Exclude if in QA mode
      if (this.context.qaMode) {
        process.env.NODE_ENV !== "production" && this.log("Skip because QA mode", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      }

      // 12.5. Exclude if experiment is stopped
      if (experiment.status === "stopped") {
        process.env.NODE_ENV !== "production" && this.log("Skip because stopped", {
          id: key
        });
        return this.getResult(experiment, -1, false, featureId);
      }

      // 13. Build the result object
      var result = this.getResult(experiment, assigned, true, featureId);

      // 14. Fire the tracking callback
      this.track(experiment, result);

      // 15. Return the result
      process.env.NODE_ENV !== "production" && this.log("In experiment", {
        id: key,
        variation: result.variationId
      });
      return result;
    }

    // eslint-disable-next-line
  }, {
    key: "log",
    value: function log(msg, ctx) {
      if (!this.debug) return;
      if (this.context.log) this.context.log(msg, ctx);else console.log(msg, ctx);
    }
  }, {
    key: "track",
    value: function track(experiment, result) {
      if (!this.context.trackingCallback) return;
      var key = experiment.key;

      // Make sure a tracking callback is only fired once per unique experiment
      var k = result.hashAttribute + result.hashValue + key + result.variationId;
      if (this._trackedExperiments.has(k)) return;
      this._trackedExperiments.add(k);
      try {
        this.context.trackingCallback(experiment, result);
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: "mergeOverrides",
    value: function mergeOverrides(experiment) {
      var key = experiment.key;
      var o = this.context.overrides;
      if (o && o[key]) {
        experiment = Object.assign({}, experiment, o[key]);
        if (typeof experiment.url === "string") {
          experiment.url = getUrlRegExp(
          // eslint-disable-next-line
          experiment.url);
        }
      }
      return experiment;
    }
  }, {
    key: "getHashAttribute",
    value: function getHashAttribute(attr) {
      var hashAttribute = attr || "id";
      var hashValue = "";
      if (this._attributeOverrides[hashAttribute]) {
        hashValue = this._attributeOverrides[hashAttribute];
      } else if (this.context.attributes) {
        hashValue = this.context.attributes[hashAttribute] || "";
      } else if (this.context.user) {
        hashValue = this.context.user[hashAttribute] || "";
      }
      return {
        hashAttribute: hashAttribute,
        hashValue: hashValue
      };
    }
  }, {
    key: "getResult",
    value: function getResult(experiment, variationIndex, hashUsed, featureId) {
      var inExperiment = true;
      // If assigned variation is not valid, use the baseline and mark the user as not in the experiment
      if (variationIndex < 0 || variationIndex >= experiment.variations.length) {
        variationIndex = 0;
        inExperiment = false;
      }
      var _this$getHashAttribut3 = this.getHashAttribute(experiment.hashAttribute),
        hashAttribute = _this$getHashAttribut3.hashAttribute,
        hashValue = _this$getHashAttribut3.hashValue;
      return {
        featureId: featureId,
        inExperiment: inExperiment,
        hashUsed: hashUsed,
        variationId: variationIndex,
        value: experiment.variations[variationIndex],
        hashAttribute: hashAttribute,
        hashValue: hashValue
      };
    }
  }, {
    key: "getContextUrl",
    value: function getContextUrl() {
      return this.context.url || (isBrowser ? window.location.href : "");
    }
  }, {
    key: "urlIsValid",
    value: function urlIsValid(urlRegex) {
      var url = this.getContextUrl();
      if (!url) return false;
      var pathOnly = url.replace(/^https?:\/\//, "").replace(/^[^/]*\//, "/");
      if (urlRegex.test(url)) return true;
      if (urlRegex.test(pathOnly)) return true;
      return false;
    }
  }, {
    key: "hasGroupOverlap",
    value: function hasGroupOverlap(expGroups) {
      var groups = this.context.groups || {};
      for (var i = 0; i < expGroups.length; i++) {
        if (groups[expGroups[i]]) return true;
      }
      return false;
    }
  }]);
  return GrowthBook;
}();